import { Box, Container, styled } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";

export const DialogContainer = styled(Box, { label: "WarrantyDamaged-Container" })
    (({ theme }) => ({
        minWidth: 650,
        gap: "10px",
        display: "flex",
        flexDirection: "column",
        maxHeight: 400,

        '> div': {
            '&:first-of-type': {
                //dentro head tabella
                borderBottom: '1px solid ' + StyleguideSavioColors.mainBlue,
                color: 'red',
                '> div': {
                    'p': {
                        fontSize: 14,
                        textTransform: 'uppercase',
                        color: StyleguideSavioColors.mainBlue,
                        fontWeight: StyleguideSavioFonts.bold,
                        width: '100%',
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        paddingTop: 9,
                        paddingBottom: 9,
                    }
                }


            }
        }
    }))

export const DialogDefectContainer = styled(Box, { label: "WarrantyDamagedDefect-Container" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        gap: 50,
        alignItems: "center",
        paddingTop:7, 
    }))

export const PaperContainer = styled(Container, { label: "WarrantyDamaged-PaperContainer" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        padding: "5px 0px",
        marginBottom: 5,




    }))

export const RowStyled = styled(Box, { label: "WarrantyDamaged-RowStyled" })
    (({ theme }) => ({
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "space-between",
    }))

export const StyledInputBox = styled(Box, { label: "StyledInput_Box" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        '.MuiInputBase-root.MuiInput-root.MuiInput-underline': {
            fontSize: 14,

            'svg': {
                transform: 'rotate(90deg)',
                fontSize: 15,
                color: StyleguideSavioColors.mainBlue,
            },
            '&:before': {
                borderColor: StyleguideSavioColors.mainBlue + " !important",
            },
            '&.Mui-error': {
                '&:before': {
                    borderColor: "#d32f2f !important",
                },
            }
        }
    }))

export const StyledInputBoxRadio = styled(Box, { label: "StyledInput_BoxRadio" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        'label': {
            fontSize: 14,
            fontWeight: 700,
            color: StyleguideSavioColors.mainBlue,
        },
        '.MuiRadio-root': {
            padding: 2,
        },
        '.MuiFormGroup-root':{
            'label':{
                marginLeft: -5,
                'span':{
                    fontSize: 14,
                    paddingTop: 1,
                }
            }
        }

    }))